import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreatmentMessageTemplateEditForm } from '../../../core/model';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ReactiveFormsModule } from '@angular/forms';
import { RegionsSelectComponent } from '../../regions-select';
import { OrganizationsSelectComponent } from '../../organizations-select';
import { HaveTreatmentPlanRadiosComponent } from '../../have-treatment-plan-radios';
import { FabricationMethodsSelectComponent } from '../../fabrication-methods-select';
import { LanguagesSelectComponent } from '../../languages-select';
import { AutoResizeTextareaDirective } from './auto-resize-textarea.directive';
import { OrderNumberPerTreatmentTypeSelectComponent } from '../../order-number-per-treatment-type-select';

@Component({
    selector: 'app-edit-treatment-message-template',
    standalone: true,
    imports: [
        CommonModule,
        InputTextareaModule,
        ReactiveFormsModule,
        RegionsSelectComponent,
        OrganizationsSelectComponent,
        HaveTreatmentPlanRadiosComponent,
        FabricationMethodsSelectComponent,
        LanguagesSelectComponent,
        AutoResizeTextareaDirective,
        OrderNumberPerTreatmentTypeSelectComponent,
    ],
    templateUrl: './edit-treatment-message-template.component.html',
    styleUrls: ['./edit-treatment-message-template.component.scss'],
})
export class EditTreatmentMessageTemplateComponent {
    @Input() form?: TreatmentMessageTemplateEditForm | null;
}
